import React, { useEffect, useState } from "react";

export const languageContext = React.createContext();

const LanguagesContext = (props) => {
    const [language, setLanguage] = useState("en");

    useEffect(() => {
        const defaultLanguage = "en";
        const currentLanguage = localStorage.getItem("data-language") || defaultLanguage;

        localStorage.setItem("data-language", currentLanguage);
        document.documentElement.setAttribute("data-language", currentLanguage);
        document.documentElement.setAttribute("lang", currentLanguage);
        setLanguage(currentLanguage)
    }, [])

    const handleLanguage = (target) => {
        localStorage.setItem("data-language", target);
        document.documentElement.setAttribute("data-language", target);
        document.documentElement.setAttribute("lang", target);
        return setLanguage(target);
    }

    const contextValue = {
        language,
        setLanguage,
        handleLanguage,
    };
    return (
        <languageContext.Provider value={contextValue}>
            {props.children}
        </languageContext.Provider>
    );
};

export default LanguagesContext;
